// import { queryString } from '@/helpers'
import { baseState, initialState, initialStateByModule } from './state'
import { createQuotations } from '@/api/services'
import { COVID_COVERS, COVID_COVERS_TOO } from '@/helpers/index'

const RESET = 'resetQuotation'

const SET_DESTINATION = 'setDestination'
const SET_COUNTRIES_SELECTED = 'setCountriesSelected'
const SET_END_DATE = 'setEndDate'
const SET_INITIAL_DATE = 'setInitialDate'
const SET_NUMBER_OF_PASSENGERS_FOURTY_YEARS =
  'setNumberOfPassengersFourtyYears'
const SET_NUMBER_OF_PASSENGERS_SIXTY_FOUR_YEARS =
  'setNumberOfPassengersSixtyFourYears'
const SET_NUMBER_OF_PASSENGERS_SEVENTY_FIVE_YEARS =
  'setNumberOfPassengersSeventyFiveYears'
const SET_NUMBER_OF_PASSENGERS_EIGHTY_FIVE_YEARS =
  'setNumberOfPassengersEightyFiveYears'
const SET_NUMBER_OF_PASSENGERS_NINETY_NINE_YEARS =
  'setNumberOfPassengersNinetyNineYears'
const SET_PROMO_CODE = 'setPromoCode'
const SET_QUOTATION = 'setQuotation'
const SET_PLAN_COVID_SELECTED = 'setPlanCovidSelected'
const SET_QUOTATION_URL = 'setQuotationUrl'
const SET_INSURER = 'setInsurer'
const HAS_ID_OLD = 'hasIdOld'
const HAS_NATIONAL = 'hasNational'
const SET_IS_NATIONAL = 'setIsNational'

const PENDING = 'createPending'
const SUCCESS = 'createSuccess'
const FAILURE = 'createFailure'

export default {
  namespaced: true,
  state: initialStateByModule('quotation'),
  getters: {
    destination: (state) => {
      return baseState.travelSetup.listDestinations.find((item) => {
        return item.codDestination === state.destinationId
      })
    },
    destinationById: () => (id) => {
      return baseState.travelSetup.listDestinations.find((item) => {
        return item.codDestination === id
      })
    },
    bestSeller: (state, getters) => {
      return Object.keys(state.result)[(getters.destination || {}).bestSeller]
    },
    covidCovers: (state) => {
      return state.insurer === 'CHUBB' ? COVID_COVERS : COVID_COVERS_TOO
    },
    selectedCovidCovers: (state, getters) => {
      const planCovid = getters.covidCovers.find(
        (obj) => obj.id === Number(state.planCovidSelected)
      )
      return planCovid
    },
    totalNumberOfPassengers: (state) => {
      return (
        parseInt(state.numberOfPassengersFourtyYears) +
        parseInt(state.numberOfPassengersSixtyFourYears) +
        parseInt(state.numberOfPassengersSeventyFiveYears) +
        parseInt(state.numberOfPassengersEightyFiveYears) +
        parseInt(state.numberOfPassengersNinetyNineYears)
      )
    },
    coversByLabel: (state) => {
      return Object.values(state.result).reduce((accumulator, value) => {
        for (let j = 0; j < value.covers.length; j++) {
          const cover = value.covers[j]
          accumulator[cover.label] = accumulator[cover.label] || {}
          accumulator[cover.label][value.planName] = cover.value
        }

        return accumulator
      }, {})
    },
    amountCovers: (state) => {
      return Object.values(state.result).reduce((accumulator, value) => {
        return value.covers
      })
    },
    firstsCoversByLabel: (state, getters) => {
      let covers = {}

      for (let index = 0; index < 3; index++) {
        const key = Object.keys(getters.coversByLabel)[index]
        covers[key] = getters.coversByLabel[key]
      }

      return covers
    },
    selectedQuote: (state) => {
      return state.result[state.selectedQuoteUuid]
    },
    partnerName: (state) => {
      const selectedQuote = state.result[state.selectedQuote]
      if (selectedQuote.liveloPoints) {
        return 'livelo'
      }
      if (selectedQuote.dotzPoints) {
        return 'dotz'
      }
    },
    showLivelo: (state) => {
      if (!state.result) {
        return false
      }
      return Object.keys(state.result).some(
        (key) => state.result[key].liveloPoints
      )
    }
  },
  mutations: {
    [RESET] (state) {
      const s = initialState.quotation
      Object.keys(s).forEach((key) => {
        state[key] = s[key]
      })
    },
    [SET_DESTINATION] (state, payload) {
      state.destinationId = payload
      state.codDestination = payload
    },
    [SET_END_DATE] (state, payload) {
      state.endDate = payload
    },
    [SET_INITIAL_DATE] (state, payload) {
      state.initialDate = payload
    },
    [SET_NUMBER_OF_PASSENGERS_FOURTY_YEARS] (state, payload) {
      state.numberOfPassengersFourtyYears = +payload
    },
    [SET_NUMBER_OF_PASSENGERS_SIXTY_FOUR_YEARS] (state, payload) {
      state.numberOfPassengersSixtyFourYears = +payload
    },
    [SET_NUMBER_OF_PASSENGERS_SEVENTY_FIVE_YEARS] (state, payload) {
      state.numberOfPassengersSeventyFiveYears = +payload
    },
    [SET_NUMBER_OF_PASSENGERS_EIGHTY_FIVE_YEARS] (state, payload) {
      state.numberOfPassengersEightyFiveYears = +payload
    },
    [SET_NUMBER_OF_PASSENGERS_NINETY_NINE_YEARS] (state, payload) {
      state.numberOfPassengersNinetyNineYears = +payload
    },
    [SET_PROMO_CODE] (state, payload) {
      state.promoCode.value = payload
    },
    [SET_PLAN_COVID_SELECTED] (state, payload) {
      state.planCovidSelected = payload
    },
    [SET_QUOTATION] (state, payload) {
      state.selectedQuoteUuid = `${payload.uuid}_${payload.code}`
    },
    [SET_COUNTRIES_SELECTED] (state, countriesId = []) {
      // countries: array with obj id
      state.countries = countriesId.split(',').map((id) => Number(id))
      // countriesSelected: obj array with countries info
      state.countriesSelected = baseState.travelSetup.listDestinations.filter(
        (obj) => state.countries.some((id) => id === obj.id)
      )
    },
    [SET_QUOTATION_URL] (state) {
      state.quotationUrl = window.location.href
    },
    [SET_INSURER] (state, isPayload) {
      state.insurer = isPayload ? 'CHUBB' : 'TOO_SEGUROS'
    },
    [PENDING] (state) {
      state.asyncPending = true
      state.promoCode.valid = undefined
    },
    [SUCCESS] (state, payload) {
      state.asyncPending = false
      state.destinationId = payload.codDestination
      state.codDestination = payload.codDestination
      state.promoCode.valid = state.promoCode.value
        ? state.promoCode.value &&
          payload.plans[0].promoCode &&
          state.promoCode.value.toUpperCase() ===
            payload.plans[0].promoCode.trim().toUpperCase()
        : undefined
      state.result = payload.plans.reduce((accumulator, current) => {
        accumulator[`${current.uuid}_${current.promoCode}`] = current
        return accumulator
      }, {})
      state.userUuid = payload.userUuid
      state.promoCodeExpiration = payload.plans[0].promoCodeExpiration
      state.insurer = payload.insurer
    },
    [FAILURE] (state) {
      state.asyncPending = false
      state.result = {}
    },
    [HAS_ID_OLD] (state, isPayload) {
      state.hasIdOld = isPayload
    },
    [HAS_NATIONAL] (state, isPayload) {
      state.hasNational = isPayload
    },
    [SET_IS_NATIONAL] (state, isNational) {
      state.isNational = isNational
    }
  },
  actions: {
    async create ({ commit, state, getters }) {
      commit(PENDING)

      const hasNational = Boolean(
        state.countriesSelected.length === 1 &&
          state.countriesSelected.find(({ id }) => id === 31)
      )

      const hasMultiTrip = ['Y15', 'Y30'].includes(state.codDestination)

      commit(SET_INSURER, hasNational || hasMultiTrip)

      const planCovidID =
        getters.selectedCovidCovers[ `${hasNational ? 'nationalId' : 'internationalId'}` ]

      const data = {
        initialDate: state.initialDate,
        endDate: state.endDate,
        fortyYears: state.numberOfPassengersFourtyYears,
        sixtyFourYears: state.numberOfPassengersSixtyFourYears,
        seventyFiveYears: state.numberOfPassengersSeventyFiveYears,
        eightyFiveYears: state.numberOfPassengersEightyFiveYears,
        ninetyNineYears: state.numberOfPassengersNinetyNineYears,
        promoCode: state.promoCode.value,
        ...(getters.covidCovers.length > 0 &&
          state.planCovidSelected && {
          planCovid: planCovidID || 'Não Incluir'
        }),
        ...(hasMultiTrip
          ? { destination: state.destinationId || state.codDestination }
          : { countries: state.countriesSelected.map(({ id }) => id) })
      }

      await createQuotations(data).then(
        (res) => {
          commit(SUCCESS, res)
        },
        (error) => {
          commit(FAILURE, error)
          this._vm.$sentry.logWithContext({
            ctx: {
              label: 'createQuotations',
              error
            },
            error
          })
        }
      )
    }
  }
}
